import { useEffect, useState } from "react";
import { fetchLottoData } from "./api.js";
import Predictor from "./components/Predictor.jsx";
import Overview from "./components/dashboard/Overview.jsx";
import Frequency from "./components/dashboard/Frequency.jsx";
import Distance from "./components/dashboard/Distance.jsx";
import Probability from "./components/dashboard/Probability.jsx";
import Parity from "./components/dashboard/Parity.jsx";
import AreaPatterns from "./components/dashboard/AreaPatterns.jsx";
import Cascading from "./components/dashboard/Cascading.jsx";
import Related from "./components/dashboard/Related.jsx";
import Verifier from "./components/dashboard/Verifier.jsx";

export default function App() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    fetchLottoData()
      .then(setData)
      .catch((e) => setErr(e.message));
  }, []);

  if (err)
    return (
      <main>
        <h1>로또 분석 대시보드</h1>
        <p style={{ color: "tomato" }}>로드 실패: {err}</p>
      </main>
    );
  if (!data)
    return (
      <main>
        <h1>로또 분석 대시보드</h1>
        <p>불러오는 중…</p>
      </main>
    );

  const { rows, lastDraw } = data;

  return (
    <main>
      <header className="page-head">
        <h1>로또 6/45 분석 대시보드</h1>
        <p className="muted">
          총 {data.rows.length} 회차 · 마지막 #{lastDraw}
        </p>
      </header>

      <div className="dash-grid">
        <Overview rows={rows} lastDraw={lastDraw} />
        <Frequency rows={rows} />
        <Distance rows={rows} />

        <Probability rows={rows} />

        <Parity rows={rows} />
        <AreaPatterns rows={rows} />
        <Cascading rows={rows} />
        <Related rows={rows} />

        <Verifier rows={rows} />

        <section className="card span-3">
          <header className="card-head">
            <h3>예측 번호 생성</h3>
            <span className="muted">번호군 패턴 + High/Low 가중</span>
          </header>
          <div className="card-body">
            <Predictor rows={rows} lastDraw={lastDraw} />
          </div>
        </section>
      </div>
    </main>
  );
}
